module.exports = __webpack_public_path__ + "img/KMD.3abccbda.svg";